import React from 'react'
import _ from 'lodash'
import { hashHistory } from 'react-router'
import * as request from 'superagent'
import { getToken } from '../Commons/Authentication'
import DefEmotState from '../../img/icons/general-icons/est_emo_0.png'
import DefPhysState from '../../img/icons/general-icons/est_fis_0.png'
import DefMentState from '../../img/icons/general-icons/est_men_0.png'
import DefSociState from '../../img/icons/general-icons/est_soc_0.png'
import GooEmotState from '../../img/icons/general-icons/est_emo_1.png'
import GooPhysState from '../../img/icons/general-icons/est_fis_1.png'
import GooMentState from '../../img/icons/general-icons/est_men_1.png'
import GooSociState from '../../img/icons/general-icons/est_soc_1.png'
import RegEmotState from '../../img/icons/general-icons/est_emo_2.png'
import RegMentState from '../../img/icons/general-icons/est_men_2.png'
import RegSociState from '../../img/icons/general-icons/est_soc_2.png'
import BadEmotState from '../../img/icons/general-icons/est_emo_3.png'
import BadPhysState from '../../img/icons/general-icons/est_fis_3.png'
import BadMentState from '../../img/icons/general-icons/est_men_3.png'
import BadSociState from '../../img/icons/general-icons/est_soc_3.png'
import PlanComponent from './PlanComponent'
export default class DashboardHealthSquares extends React.Component {
  constructor(props) {
    super(props)
    this.state = ({
      squares: {},
      /* Estado fisico */
      edadVascular: '', reservaFunc: '',
      fragilidad: '', sintomas: '', descripcion: '',
      alimentacion: '', dreams: '', relajacion: '',
      adicciones: '', actividadFisica: '',
      /* Estado mental */
      adversidades: '', presentes: '', futuro: '',
      tranquilidad: '', perspectivaVal: '',
      /* Estado social */
      redFamiliar: '', trabajoAgradable: '', pensionado: '',
      autonomia: '', redSocial: '', oportunidades: '', tiempolibre: '',
      /* Estado Emocional */
      par1: '', par2: '', par3: '',
      /* Phys Square Class */
      phyClass: 'health-square left-square',
      phyTextClass: 'state-text',
      /* Ment Square Class */
      menClass: 'health-square right-square',
      menTextClass: 'state-text',
      /* Soci Square Class */
      socClass: 'health-square left-square',
      socTextClass: 'state-text',
      /* Emot Square Class */
      emoClass: 'health-square right-square',
      emoTextClass: 'state-text',
      /* Square Images */
      ImgEmotState: DefEmotState,
      ImgPhysState: DefPhysState,
      ImgMentState: DefMentState,
      ImgSociState: DefSociState,
      /* Validators */
      mensajeEdad: '',
      mensajeReserva: '',
      acumuladorFisico: 0,
      acumuladorMental: 0,
      acumuladorSocial: 0,
      acumuladorEmocional: 0
    })
  }

  componentWillMount() {
    request
      .get('api/v1/square/findSquareById?id=' + this.props.identification)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          console.log(err)
        }
        if (res.status === 201) {
          let model = res.body[0]
          this.setState({
            squares: model,
            /* Estado fisico */
            edadVascular: model.edadVascular, reservaFunc: model.reservaFunc,
            fragilidad: model.fragilidad, sintomas: model.sintomas,
            alimentacion: model.alimentacion, dreams: model.dreams, relajacion: model.relajacion,
            adicciones: model.adicciones, actividadFisica: model.actividadFisica,
            /* Estado mental */
            adversidades: model.adversidades, presentes: model.presentes, futuro: model.futuro,
            tranquilidad: model.tranquilidad, tiempolibre: model.tiempolibre,
            /* Estado social */
            redFamiliar: model.redFamiliar, trabajoAgradable: model.trabajoAgradable, pensionado: model.pensionado,
            autonomia: model.autonomia, redSocial: model.redSocial, oportunidades: model.oportunidades,
            /* Estado Emocional */
            par1: model.par1, par2: model.par2, par3: model.par3
          })

          this.estadoFisicoClass()
          this.estadoMentalClass()
          this.estadoSocialClass()
          this.estadoEmocionalClass()
        }
      })
  }

  estadoFisicoClass() {
    let cronologicalAge = this.props.data.patientAge
    let diferenciaEdades = this.state.edadVascular - cronologicalAge

    if (diferenciaEdades < 6) {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico, mensajeEdad: ' (En rango apropiado)' })
    } else if (diferenciaEdades >= 6) {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1, mensajeEdad: ' (Alto Riesgo)' })
    }

    if (this.state.reservaFunc >= 60) {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico, mensajeReserva: ' (Apropiada)' })
    } else if (this.state.reservaFunc < 60) {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1, mensajeReserva: ' (Inapropiada)' })
    }

    if (this.state.actividadFisica >= 7) {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico })
    } else if (this.state.actividadFisica < 7) {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1 })
    }

    if (this.state.fragilidad === 'No') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico })
    } else if (this.state.fragilidad === 'Si') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1 })
    }

    if (this.state.sintomas === 'No') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico })
    } else if (this.state.sintomas === 'Si') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1 })
    }

    if (this.state.adicciones === 'No') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico })
    } else if (this.state.adicciones === 'Si') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1 })
    }

    if (this.state.alimentacion === 'b') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico })
    } else if (this.state.alimentacion === 'm') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1 })
    }

    if (this.state.dreams === 'b') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico })
    } else if (this.state.dreams === 'm') {
      this.setState({ acumuladorFisico: this.state.acumuladorFisico + 1 })
    }

    if (this.state.acumuladorFisico >= 1) {
      this.setState({ ImgPhysState: BadPhysState, phyClass: 'health-square-bad left-square', phyTextClass: 'state-text-bad' })
    } else if ((this.state.acumuladorFisico === 0) && (!_.isEmpty(this.state.squares))) {
      this.setState({ ImgPhysState: GooPhysState, phyClass: 'health-square-good left-square', phyTextClass: 'state-text-good' })
    } else {
      this.state.phyClass
      this.state.ImgPhysState
      this.state.phyTextClass
    }
  }

  estadoMentalClass() {
    if (this.state.adversidades === 'Positiva') {
      this.setState({ acumuladorMental: this.state.acumuladorMental })
    } else if (this.state.adversidades === 'Negativa') {
      this.setState({ acumuladorMental: this.state.acumuladorMental + 1 })
    }

    if (this.state.futuro === 'Optimismo') {
      this.setState({ acumuladorMental: this.state.acumuladorMental })
    } else if (this.state.futuro === 'Pesimismo') {
      this.setState({ acumuladorMental: this.state.acumuladorMental + 1 })
    }

    if (this.state.presentes === 'Si') {
      this.setState({ acumuladorMental: this.state.acumuladorMental })
    } else if (this.state.presentes === 'No') {
      this.setState({ acumuladorMental: this.state.acumuladorMental + 1 })
    }

    if (this.state.tranquilidad === 'Si') {
      this.setState({ acumuladorMental: this.state.acumuladorMental })
    } else if (this.state.tranquilidad === 'No') {
      this.setState({ acumuladorMental: this.state.acumuladorMental + 1 })
    }

    if (this.state.tiempolibre === 'Si') {
      this.setState({ acumuladorMental: this.state.acumuladorMental })
    } else if (this.state.tiempolibre === 'No') {
      this.setState({ acumuladorMental: this.state.acumuladorMental + 1 })
    }

    if (this.state.acumuladorMental >= 3) {
      this.setState({ ImgMentState: BadMentState, menClass: 'health-square-bad right-square', menTextClass: 'state-text-bad' })
    } else if ((this.state.acumuladorMental >= 1) && (this.state.acumuladorMental <= 2)) {
      this.setState({ ImgMentState: RegMentState, menClass: 'health-square-regular right-square', menTextClass: 'state-text-regular' })
    } else if ((this.state.acumuladorMental === 0) && (!_.isEmpty(this.state.squares))) {
      this.setState({ ImgMentState: GooMentState, menClass: 'health-square-good right-square', menTextClass: 'state-text-good' })
    } else {
      this.state.menClass
      this.state.ImgMentState
      this.state.menTextClass
    }
  }

  estadoSocialClass() {
    if (this.state.redFamiliar === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.redFamiliar === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.trabajoAgradable === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.trabajoAgradable === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.pensionado === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.pensionado === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.autonomia === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.autonomia === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.redSocial === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.redSocial === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.oportunidades === 'Si') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial })
    } else if (this.state.oportunidades === 'No') {
      this.setState({ acumuladorSocial: this.state.acumuladorSocial + 1 })
    }

    if (this.state.acumuladorSocial >= 4) {
      this.setState({ ImgSociState: BadSociState, socClass: 'health-square-bad left-square', socTextClass: 'state-text-bad' })
    } else if (this.state.acumuladorSocial === 3) {
      this.setState({ ImgSociState: RegSociState, socClass: 'health-square-regular left-square', socTextClass: 'state-text-regular' })
    } else if ((this.state.acumuladorSocial <= 2) && (this.state.acumuladorSocial >= 0)) {
      this.setState({ ImgSociState: GooSociState, socClass: 'health-square-good left-square', socTextClass: 'state-text-good' })
    } else {
      this.state.socClass
      this.state.ImgSociState
      this.state.socTextClass
    }
  }

  estadoEmocionalClass() {
    if (this.state.par1 === 'Contento') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional })
    } else if (this.state.par1 === 'Descontento') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional + 1 })
    }

    if (this.state.par2 === 'Calmado') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional })
    }

    if (this.state.par2 === 'Expresivo') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional })
    }

    if (this.state.par3 === 'Entusiasta') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional })
    } else if (this.state.par3 === 'Irritable : DEA') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional + 1 })
    }

    if (this.state.par3 === 'Tranquilo') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional })
    } else if (this.state.par3 === 'Decaído') {
      this.setState({ acumuladorEmocional: this.state.acumuladorEmocional + 1 })
    }

    if (this.state.acumuladorEmocional >= 2) {
      this.setState({ ImgEmotState: BadEmotState, emoClass: 'health-square-bad right-square', emoTextClass: 'state-text-bad' })
    } else if (this.state.acumuladorEmocional === 1) {
      this.setState({ ImgEmotState: RegEmotState, emoClass: 'health-square-regular right-square', emoTextClass: 'state-text-regular' })
    } else if ((this.state.acumuladorEmocional === 0) && (!_.isEmpty(this.state.squares))) {
      this.setState({ ImgEmotState: GooEmotState, emoClass: 'health-square-good right-square', emoTextClass: 'state-text-good' })
    } else {
      this.state.emoClass
      this.state.ImgEmotState
      this.state.emoTextClass
    }
  }

  squaresCapture(e) {
    e.preventDefault()
    hashHistory.push('medicalSquares/' + this.props.identification)
  }

  render() {
    return (
      <div className='health-square-container square-redirect'>
        <div onClick={this.squaresCapture.bind(this)}>
          <div className='header-medical-data'>
            <div className='section-title'>
              <div className='square-title'>
                <div className='medical-link' data={this.props.data}>Cuadrante general</div>
              </div>
            </div>
          </div>
          <div className='square-container'>
            <div className='health-squares top-squares'>
              <div className={this.state.phyClass}>
                <div className='square-header-title'>
                  <img className='state-img' src={this.state.ImgPhysState} />
                  <div className={this.state.phyTextClass}>Estado Físico</div>
                </div>
                <div className='state-text-result'>
                  <div className='state-labels'>{this.state.edadVascular ? 'EA: ' + this.state.edadVascular + ' años.' + this.state.mensajeEdad : null}</div>
                  <div className='state-labels'>{this.state.reservaFunc ? 'RF: ' + this.state.reservaFunc + '%' + this.state.mensajeReserva : null}</div>
                  <div className='state-labels'>{(this.state.fragilidad === 'Si') ? 'Es frágil.' : (this.state.fragilidad === 'No') ? 'No es fragil.' : null}</div>
                  <div className='state-labels'>{(this.state.alimentacion === 'b') ? 'Buena alimentación.' : (this.state.alimentacion === 'n') ? 'Alimentación regular.' : (this.state.alimentacion === 'm') ? 'Mala alimentación.' : null}</div>
                  <div className='state-labels'>{(this.state.adicciones === 'Si') ? 'Tiene adicciones' : (this.state.adicciones === 'No') ? 'No tiene adicciones' : null}</div>
                  <div className='state-labels'>{(this.state.dreams === 'b') ? 'Duerme bien.' : (this.state.dreams === 'n') ? 'Duerme regular.' : (this.state.dreams === 'm') ? 'Duerme mal.' : null}</div>
                </div>
              </div>
              <div className={this.state.menClass}>
                <div className='square-header-title'>
                  <img className='state-img' src={this.state.ImgMentState} />
                  <div className={this.state.menTextClass}>Estado Mental</div>
                </div>
                <div className='state-text-result'>
                  <div className='state-labels'>{(this.state.adversidades === 'Positiva') ? 'Perspectiva personal positiva' : (this.state.adversidades === 'Negativa') ? 'Perspectiva personal negativa' : null}</div>
                  <div className='state-labels'>{(this.state.presentes === 'Si') ? 'Tiene proyectos/planes' : (this.state.presentes === 'No') ? 'No tiene proyectos/planes' : null}</div>
                  <div className='state-labels'>{(this.state.futuro === 'Optimismo') ? 'Es optimista respecto a su futuro' : (this.state.futuro === 'Pesimismo') ? 'Es pesimista respecto a su futuro' : null}</div>
                  <div className='state-labels'>{(this.state.tranquilidad === 'Si') ? 'Tranquilidad financiera' : (this.state.tranquilidad === 'No') ? 'Intranquilidad financiera' : null}</div>
                  <div className='state-labels'>{(this.state.tiempolibre === 'Si') ? 'Realiza actividades en tiempo libre' : (this.state.tiempolibre === 'No') ? 'No hace nada en tiempo libre' : null}</div>
                </div>
              </div>
            </div>
            <div className='health-squares'>
              <div className={this.state.socClass}>
                <div className='square-header-title'>
                  <img className='state-img' src={this.state.ImgSociState} />
                  <div className={this.state.socTextClass}>Estado Social</div>
                </div>
                <div className='state-text-result'>
                  <div className='state-labels'>{(this.state.redFamiliar === 'Si') ? 'Tiene apoyo familiar' : (this.state.redFamiliar === 'No') ? 'No tiene apoyo familiar' : null}</div>
                  <div className='state-labels'>{(this.state.trabajoAgradable === 'Si') ? 'Tiene un trabajo agradable' : (this.state.trabajoAgradable === 'No') ? 'No tiene un trabajo agradable' : null}</div>
                  <div className='state-labels'>{(this.state.pensionado === 'Si') ? 'Es pensionado' : (this.state.pensionado === 'No') ? 'No es pensionado' : null}</div>
                  <div className='state-labels'>{(this.state.oportunidades === 'Si') ? 'Tiene oportunidades de progreso' : (this.state.oportunidades === 'No') ? 'Sin oportunidades de progreso' : null}</div>
                  <div className='state-labels'>{(this.state.redSocial === 'Si') ? 'Hace parte de un grupo social' : (this.state.redSocial === 'No') ? 'No hace parte de un grupo social' : null}</div>
                  <div className='state-labels'>{(this.state.autonomia === 'Si') ? 'Es una persona autónoma' : (this.state.autonomia === 'No') ? 'No es una persona autónoma' : null}</div>
                </div>
              </div>
              <div className={this.state.emoClass}>
                <div className='square-header-title'>
                  <img className='state-img' src={this.state.ImgEmotState} />
                  <div className={this.state.emoTextClass}>Estado Emocional</div>
                </div>
                <div className='state-text-result'>
                  <div className='state-labels'>{this.state.par1}</div>
                  <div className='state-labels'>{this.state.par2}</div>
                  <div className='state-labels'>{this.state.par3}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <PlanComponent identification={this.props.identification}></PlanComponent>
      </div>
    )
  }
}

/* Validate Props */
DashboardHealthSquares.propTypes = {
  identification: React.PropTypes.string,
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardHealthSquaresComponent.js